import { render, staticRenderFns } from "./commentRequest.vue?vue&type=template&id=3ce07716&scoped=true"
import script from "./commentRequest.vue?vue&type=script&lang=js"
export * from "./commentRequest.vue?vue&type=script&lang=js"
import style0 from "./commentRequest.vue?vue&type=style&index=0&id=3ce07716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce07716",
  null
  
)

export default component.exports